import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Search, MapPin, Phone, Building2, Share2 } from "lucide-react";
import { Helmet } from "react-helmet-async";
import toast from "react-hot-toast";

export default function Panchayaths() {
  const [search, setSearch] = useState("");

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
  };

  // 🔥 10 ഗ്രാമപഞ്ചായത്തുകളുടെ വിവരങ്ങൾ 🔥
  const panchayathData = [
    {
      id: 1,
      name: "കല്ല്യാശ്ശേരി ഗ്രാമപഞ്ചായത്ത്",
      englishName: "Kalliasseri",
      officePhone: "0497-2782755",
      description: "മാങ്ങാട്ടുപറമ്പ് യൂണിവേഴ്സിറ്റി ക്യാമ്പസ്, കെൽട്രോൺ എന്നിവ സ്ഥിതി ചെയ്യുന്ന കല്ല്യാശ്ശേരി മണ്ഡലത്തിന്റെ ആസ്ഥാനം."
    },
    {
      id: 2,
      name: "കണ്ണപുരം ഗ്രാമപഞ്ചായത്ത്",
      englishName: "Kannapuram",
      officePhone: "0497-2860228",
      description: "കൈത്തറി നെയ്ത്തിന് പേരുകേട്ട, കാൻസർ വിമുക്ത പ്രവർത്തനങ്ങളിൽ രാജ്യത്തിന് തന്നെ മാതൃകയായ ഗ്രാമം."
    },
    {
      id: 3,
      name: "ചെറുകുന്ന് ഗ്രാമപഞ്ചായത്ത്",
      englishName: "Cherukunnu",
      officePhone: "0497-2860233",
      description: "അന്നപൂർണ്ണേശ്വരി ക്ഷേത്രം, മിഷൻ ആശുപത്രി എന്നിവയാൽ പ്രശസ്തമായ മണ്ഡലത്തിലെ പ്രധാന വാണിജ്യ കേന്ദ്രം."
    },
    {
      id: 4,
      name: "മാടായി ഗ്രാമപഞ്ചായത്ത്",
      englishName: "Madayi",
      officePhone: "0497-2870230",
      description: "ചരിത്രപ്രസിദ്ധമായ മാടായിപ്പാറ, മാടായിക്കാവ്, പഴയങ്ങാടി ടൗൺ എന്നിവ ഉൾക്കൊള്ളുന്ന പ്രദേശം."
    },
    {
      id: 5,
      name: "മാട്ടൂൽ ഗ്രാമപഞ്ചായത്ത്",
      englishName: "Mattool",
      officePhone: "0497-2843530",
      description: "അറബിക്കടലിനും വളപട്ടണം പുഴയ്ക്കും ഇടയിലായി സ്ഥിതി ചെയ്യുന്ന മനോഹരമായ തീരദേശ ഗ്രാമം."
    },
    {
      id: 6,
      name: "ഏഴോം ഗ്രാമപഞ്ചായത്ത്",
      englishName: "Ezhome",
      officePhone: "0497-2870243",
      description: "കർഷക സമരങ്ങളുടെ ഈറ്റില്ലവും, കൈപ്പാട് കൃഷിക്ക് പേരുകേട്ടതുമായ കാർഷിക ഗ്രാമം."
    },
    {
      id: 7,
      name: "ചെറുതാഴം ഗ്രാമപഞ്ചായത്ത്",
      englishName: "Cheruthazham",
      officePhone: "0497-2800366",
      description: "ഹനുമാരമ്പലം, ശ്രീസ്ഥ തുടങ്ങിയ ക്ഷേത്രങ്ങളാലും തെയ്യം കലാരൂപങ്ങളാലും സമ്പന്നമായ പ്രദേശം."
    },
    {
      id: 8,
      name: "കുഞ്ഞിമംഗലം ഗ്രാമപഞ്ചായത്ത്",
      englishName: "Kunhimangalam",
      officePhone: "0497-2800455",
      description: "ഓട്ടുപാത്ര നിർമ്മാണത്തിന് കേരളമൊട്ടാകെ പ്രശസ്തമായ പൈതൃക ഗ്രാമം."
    },
    {
      id: 9,
      name: "കടന്നപ്പള്ളി-പാണപ്പുഴ",
      englishName: "Kadannappalli-Panapuzha",
      officePhone: "0498-5240030",
      description: "കുന്നുകളും വയലുകളും നിറഞ്ഞ അതിമനോഹരമായ പ്രകൃതിഭംഗിയുള്ള കാർഷിക ഗ്രാമം."
    },
    {
      id: 10,
      name: "പട്ടുവം ഗ്രാമപഞ്ചായത്ത്",
      englishName: "Pattuvam",
      officePhone: "0460-2244243",
      description: "കുപ്പം പുഴയാൽ ചുറ്റപ്പെട്ടതും, കണ്ടൽക്കാടുകളാൽ സമ്പന്നവുമായ പ്രകൃതിരമണീയമായ പ്രദേശം."
    }
  ];

  const filteredPanchayaths = panchayathData.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase()) ||
    item.englishName.toLowerCase().includes(search.toLowerCase())
  );

  const handlePageShare = async () => {
    const shareData = {
      title: "Grama Panchayaths | Info Payangadi",
      text: "കല്യാശ്ശേരി നിയോജക മണ്ഡലത്തിലെ 10 ഗ്രാമപഞ്ചായത്തുകളുടെ വിവരങ്ങളും ഓഫീസ് നമ്പറുകളും ഒറ്റ ക്ലിക്കിൽ അറിയാൻ ഈ ലിങ്ക് സന്ദർശിക്കുക.",
      url: "https://info.payangadilive.com/panchayath" 
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.error("Error sharing:", err);
      }
    } else {
      navigator.clipboard.writeText(shareData.url);
      toast.success("ലിങ്ക് കോപ്പി ചെയ്തിട്ടുണ്ട്! (Link Copied)");
    }
  };

  return (
    <>
      {/* 🔥 Full SEO Tags 🔥 */}
      <Helmet>
        <title>Grama Panchayaths | Info Payangadi</title>
        <meta name="description" content="കല്യാശ്ശേരി നിയോജക മണ്ഡലത്തിലെ 10 ഗ്രാമപഞ്ചായത്തുകളുടെ വിവരങ്ങൾ, ഓഫീസുകൾ, ഫോൺ നമ്പറുകൾ എന്നിവ ലഭ്യമാണ്." />
        <meta name="keywords" content="Kalliasseri Panchayath, Madayi Panchayath, Cherukunnu, Mattool, Ezhome, Local body Kalliasseri, Info Payangadi" />
        
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://info.payangadilive.com/panchayath" />
        <meta property="og:title" content="Grama Panchayaths | Info Payangadi" />
        <meta property="og:description" content="കല്യാശ്ശേരി നിയോജക മണ്ഡലത്തിലെ 10 ഗ്രാമപഞ്ചായത്തുകളുടെ പൂർണ്ണ വിവരങ്ങൾ ഒറ്റ ക്ലിക്കിൽ." />
        <meta property="og:image" content="https://info.payangadilive.com/Infopayangadi.jpg" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Grama Panchayaths | Info Payangadi" />
        <meta name="twitter:description" content="കല്യാശ്ശേരി നിയോജക മണ്ഡലത്തിലെ ഗ്രാമപഞ്ചായത്തുകളുടെ ഡയറക്ടറി." />
        <meta name="twitter:image" content="https://info.payangadilive.com/Infopayangadi.jpg" />
      </Helmet>

      <div className="min-h-[100dvh] bg-[#F8FAFC] pb-24 selection:bg-blue-200 overflow-x-hidden relative">
        
        {/* Background Glows (Purple Theme) */}
        <div className="absolute top-[-10%] left-[-10%] w-[350px] h-[350px] bg-purple-400/15 rounded-full blur-[100px] pointer-events-none"></div>
        <div className="absolute top-[20%] right-[-10%] w-[350px] h-[350px] bg-blue-400/10 rounded-full blur-[100px] pointer-events-none"></div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-8 md:pt-12 relative z-10">
          
          {/* 🌟 TITLE & SHARE BUTTON SECTION 🌟 */}
          <div className="text-center mb-10 px-2 flex flex-col items-center">
            <div className="inline-flex items-center justify-center p-3.5 bg-white text-purple-600 rounded-2xl mb-3 shadow-[0_8px_30px_rgb(147,51,234,0.12)] border border-purple-50">
              <Building2 size={32} strokeWidth={2.5} />
            </div>
            <h2 className="text-3xl sm:text-4xl font-black text-slate-800 tracking-tight">
              Grama <span className="text-purple-600">Panchayaths</span>
            </h2>
            <p className="text-sm sm:text-base text-slate-500 mt-1 font-medium">കല്യാശ്ശേരി നിയോജക മണ്ഡലത്തിലെ 10 ഗ്രാമപഞ്ചായത്തുകൾ</p>

            {/* Page Share Button */}
            <motion.button
              whileTap={{ scale: 0.95 }}
              onClick={handlePageShare}
              className="mt-4 flex items-center gap-2 bg-white hover:bg-purple-50 text-slate-600 hover:text-purple-600 px-5 py-2.5 rounded-full shadow-sm border border-slate-200 transition-all duration-200 font-bold text-sm"
            >
              <Share2 size={16} strokeWidth={2.5} />
              Share Page
            </motion.button>
          </div>

          {/* 🔍 SEARCH SECTION 🔍 */}
          <div className="max-w-2xl mx-auto mb-10 px-1">
            <div className="relative group">
              <Search size={20} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-purple-500 transition-colors" strokeWidth={2.5} />
              <input
                type="text"
                placeholder="പഞ്ചായത്തിന്റെ പേര് തിരയുക..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                /* 🔥 FIX: Font size reduced to text-sm & text-base 🔥 */
                className="w-full pl-11 pr-4 py-3.5 rounded-2xl border border-slate-200 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.03)] focus:ring-4 focus:ring-purple-500/10 focus:border-purple-400 outline-none transition-all text-sm sm:text-base font-semibold text-slate-800 placeholder:text-slate-400"
              />
            </div>
          </div>

          {/* 🏛️ PANCHAYATHS GRID */}
          <motion.div 
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="grid md:grid-cols-2 gap-4 sm:gap-6"
          >
            <AnimatePresence>
              {filteredPanchayaths.map((item) => (
                <motion.div
                  key={item.id}
                  variants={itemVariants}
                  layout
                  className="bg-white rounded-[2rem] p-6 sm:p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_15px_40px_rgb(147,51,234,0.08)] transition-all duration-300 border border-slate-100 relative overflow-hidden group flex flex-col h-full"
                >
                  
                  {/* Decorative Circle */}
                  <div className="absolute top-0 right-0 w-24 h-24 bg-purple-50/50 rounded-bl-[80px] -z-10 group-hover:scale-110 transition-transform duration-500"></div>

                  {/* Header */}
                  <div className="flex items-start justify-between mb-4">
                    <div className="pr-4">
                      <h3 className="text-xl sm:text-2xl font-black text-slate-800 mb-1 tracking-tight">{item.name}</h3>
                      <p className="text-[10px] sm:text-xs font-black text-purple-600 uppercase tracking-widest">{item.englishName}</p>
                    </div>
                    <div className="p-3 bg-purple-50 rounded-2xl text-purple-600 group-hover:bg-purple-600 group-hover:text-white transition-colors duration-300 shrink-0">
                      <MapPin size={22} strokeWidth={2.5} />
                    </div>
                  </div>

                  {/* Description */}
                  <div className="flex-grow mb-6">
                    <p className="text-slate-500 text-xs sm:text-sm font-medium leading-relaxed">
                      {item.description}
                    </p>
                  </div>

                  {/* Contact Info Bottom */}
                  <div className="bg-slate-50 rounded-2xl p-4 sm:p-5 mt-auto border border-slate-100/50 group-hover:border-purple-100 transition-colors">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3 text-slate-600">
                        <div className="p-2 bg-white rounded-xl shadow-sm border border-slate-100">
                          <Building2 size={18} strokeWidth={2.5} className="text-slate-400" />
                        </div>
                        <div>
                          <p className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-slate-400">Office Phone</p>
                          <p className="text-sm sm:text-base font-black text-slate-800">{item.officePhone}</p>
                        </div>
                      </div>
                      
                      {item.officePhone !== "നമ്പർ ലഭ്യമല്ല" && (
                        <a 
                          href={`tel:${item.officePhone}`}
                          className="p-3 bg-white hover:bg-purple-600 text-purple-600 hover:text-white rounded-xl transition-all duration-300 shadow-sm border border-purple-100 shrink-0"
                          title="Call Office"
                        >
                          <Phone size={18} strokeWidth={2.5} />
                        </a>
                      )}
                    </div>
                  </div>

                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>

          {/* No Results */}
          {filteredPanchayaths.length === 0 && (
            <motion.div 
              initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}
              className="text-center py-16 bg-white rounded-[2.5rem] border border-dashed border-slate-200 mt-4"
            >
              <div className="inline-flex items-center justify-center p-4 bg-slate-50 rounded-2xl mb-4">
                <Search size={32} className="text-slate-300" strokeWidth={2.5} />
              </div>
              <h3 className="text-lg sm:text-xl font-black text-slate-700 tracking-tight">പഞ്ചായത്ത് കണ്ടെത്താനായില്ല</h3>
              <p className="text-slate-400 mt-1 text-sm font-medium">നിങ്ങൾ തിരഞ്ഞ പേര് കൃത്യമാണോ എന്ന് പരിശോധിക്കുക.</p>
            </motion.div>
          )}

        </div>
      </div>
    </>
  );
}